export const calenderConstants = {
    EVENT_TYPE: "Event",
    COMPETITION_TYPE: "Competition",
    CENTER_TYPE: "CenterActivity"
  };
  